export const FooterData = [
  {
    heading: "Company",
    offset: true,
    item: [
      {
        FItem: "About Us",
        linkL: "/about-us/",
      },
      {
        FItem: "Hajj 2025",
        linkL: "/hajj/package-1/",
      },
      {
        FItem: "Umrah 2025",
        linkL: "/package1/",
      },
      //   {
      //     FItem: "",
      //     linkL: "/#",
      //   },
      {
        FItem: "Testimonials",
        linkL: "/testimonials/",
      },
      {
        FItem: "Media",
        linkL: "/gallery/",
      },
    ],
  },
  {
    heading: "Support",
    offset: false,
    item: [
      //   {
      //     FItem: "Account",
      //     linkL: "/#",
      //   },
      {
        FItem: "Faq",
        linkL: "/faqs/",
      },

      {
        FItem: "Contact",
        linkL: "/contact-us/",
      },

      {
        FItem: "Privacy Policy",
        linkL: "/privacy-policy/",
      },
    ],
  },
  {
    heading: "Other Services",
    offset: false,
    item: [
      {
        FItem: "Corporate Travel",
        linkL: "/corporate-travel/",
      },
      {
        FItem: "Travel Consulting",
        linkL: "/travel-consulting/",
      },
      {
        FItem: "Religous Travel",
        linkL: "/religous-travel/",
      },
      {
        FItem: "Visa",
        linkL: "/visa/",
      },
      //   {
      //     FItem: "Partners",
      //     linkL: "/top-destinations",
      //   },
      //   {
      //     FItem: "List My Hotel",
      //     linkL: "/privacy-policy",
      //   },
    ],
  },
  {
    heading: "Top cities",
    offset: false,
    item: [
      {
        FItem: "Chicago",
        linkL: "/contact-us/?city=Chicago",
      },
      {
        FItem: "New York",
        linkL: "/contact-us/?city=New York",
      },
      {
        FItem: "San Francisco",
        linkL: "/contact-us/?city=San Francisco",
      },
      {
        FItem: "California",
        linkL: "/contact-us/?city=California",
      },
      {
        FItem: "Alaska",
        linkL: "/contact-us/?city=Alaska",
      },
      //   {
      //     FItem: "Alaska",
      //     linkL: "/privacy-policy",
      //   },
    ],
  },
];
